export enum IdentityLogoutResultType {
  Resolve = 'resolve',
  Reject = 'reject',
}

type IdentityLogoutResolveResult = {
  resultType: IdentityLogoutResultType.Resolve;
}

type IdentityLogoutRejectResult = {
  resultType: IdentityLogoutResultType.Reject;
  error: unknown;
}

export type IdentityLogoutResult = IdentityLogoutResolveResult | IdentityLogoutRejectResult
